/* eslint-disable */
import React from 'react'
import Accordion from '../../components/accordion'
import Sidebar from './sidebar-privary-policy'
import { Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import { useTranslation } from 'react-i18next'

const HelpPageStyle = styled.div`
  @media screen and (min-width: 300px) and (max-width: 700px) {
    .sidebar-help-custom-navigation {
      width: 100% !important;
      margin-bottom: 20px;
    }

    .sidebar-help-custom-content {
      width: 100% !important;
      padding-left: 0 !important;
    }
  }
`

const PrivacyPolicy = () => {
  const { t } = useTranslation()
  const data = [
    {
      title: t('pagePrivacyPolicy.part1'),
      number: 1,
      targetScroll: 'privacy-1',
      desc: t('pagePrivacyPolicy.part2')
    },
    {
      title: t('pagePrivacyPolicy.part3'),
      number: 2,
      targetScroll: 'privacy-2',
      desc: t('pagePrivacyPolicy.part4')
    },
    {
      title: t('pagePrivacyPolicy.part5'),
      number: 3,
      targetScroll: 'privacy-3',
      desc: t('pagePrivacyPolicy.part6')
    },
    {
      title: t('pagePrivacyPolicy.part7'),
      number: 4,
      targetScroll: 'privacy-4',
      desc: t('pagePrivacyPolicy.part8')
    },
    {
      title: t('pagePrivacyPolicy.part9'),
      number: 5,
      targetScroll: 'privacy-5',
      desc: t('pagePrivacyPolicy.part10')
    },
    {
      title: t('pagePrivacyPolicy.part11'),
      number: 6,
      targetScroll: 'privacy-6',
      desc: t('pagePrivacyPolicy.part12')
    },
    {
      title: t('pagePrivacyPolicy.part13'),
      number: 7,
      targetScroll: 'privacy-7',
      desc: t('pagePrivacyPolicy.part14')
    },
    {
      title: t('pagePrivacyPolicy.part15'),
      number: 8,
      targetScroll: 'privacy-8',
      desc: t('pagePrivacyPolicy.part16')
    },
    {
      title: t('pagePrivacyPolicy.part17'),
      number: 9,
      targetScroll: 'privacy-9',
      desc: t('pagePrivacyPolicy.part18')
    },
    {
      title: t('pagePrivacyPolicy.part19'),
      number: 10,
      targetScroll: 'privacy-10',
      desc: t('pagePrivacyPolicy.part20')
    },
    {
      title: t('pagePrivacyPolicy.part21'),
      number: 11,
      targetScroll: 'privacy-11',
      desc: t('pagePrivacyPolicy.part22')
    },
    {
      title: t('pagePrivacyPolicy.part23'),
      number: 12,
      targetScroll: 'privacy-12',
      desc: t('pagePrivacyPolicy.part24')
    }
  ]
  return (
    <div style={{ width: '100%' }}>
      <HelpPageStyle>
        <Helmet>
          <title>Kebijakan Privasi | halojasa.com</title>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Ketahui di sini mengenai kebijakan privasi di Halo Jasa"
          />
          <meta
            property="og:title"
            content="Kebijakan Privasi | halojasa.com"
          />
          <meta property="og:site_name" content="Halo Jasa" />
          <meta
            property="og:description"
            content="Ketahui di sini mengenai kebijakan privasi di Halo Jasa"
          />
          <meta
            property="og:url"
            content="https://halojasa.com/bantuan/privacy/"
          />
          <meta
            property="og:image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            property="og:image:secure_url"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            property="og:image"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta
            property="og:image:secure_url"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <meta property="og:type" content="website" />
          <meta property="fb:app_id" content="951866408583742" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@pthalojasa" />
          <meta
            name="twitter:title"
            content="Kebijakan Privasi | halojasa.com"
          />
          <meta
            name="twitter:description"
            content="Ketahui di sini mengenai kebijakan privasi di Halo Jasa"
          />
          <meta
            name="twitter:image:src"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            name="p:domain_verify"
            content="4e6fcb4deba1a02d84225fad69babc0b"
          />
          <meta name="keyword" content="kebijakan privasi halo jasa" />
          <link rel="canonical" href="https://halojasa.com/bantuan/privacy/" />
        </Helmet>
        <Col
          style={{
            width: '350px',
            display: 'inline-block',
            verticalAlign: 'top'
          }}
          className="sidebar-help-custom-navigation"
        >
          <Sidebar />
        </Col>

        <Col
          style={{
            width: 'calc(100% - 350px)',
            display: 'inline-block',
            verticalAlign: 'top',
            boxSizing: 'border-box',
            paddingLeft: '20px'
          }}
          className="sidebar-help-custom-content"
        >
          {data.map(item => {
            return (
              <Accordion key={item.number} {...item} withNumber></Accordion>
            )
          })}
        </Col>
      </HelpPageStyle>
    </div>
  )
}

export default PrivacyPolicy
